// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3m0WY","title":"BackImages_title__3Hnzg","images":"BackImages_images__1Nexh"};